import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

const FormLabelStyle = ({ error }) => css``;

const FormLabel = (props: any) => (
  <label {...props}>
    {props.children}
    {props.required && <span className="is-required">*</span>}
  </label>
);

const FormLabelStyled = styled(FormLabel)`
  ${FormLabelStyle}
`;

export default FormLabelStyled;
